import React, { useRef, useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import * as yup from 'yup';
import _ from 'lodash';
import { useFormik, FormikProvider } from 'formik';
import * as chanceApi from '../../../lib/api/chance';
import {
  chanceEstimateActive,
  chanceOrderCount,
  setChance,
} from '../../../modules/chanceModule/chance';
import DetailTemplate from '../../../components/common/template/DetailTemplate';
import CostCalcLockContainer from '../costcalc/CostCalcLockContainer';
import CostCalcListForm from '../../../components/chancemng/costcalc/CostCalcListForm';
import AskDialog from '../../../components/common/dialog/AskDialog';
import { listChanceCosts } from '../../../modules/chanceModule/chanceCosts';
import ChanceDetailForm from '../../../components/chancemng/detail/ChanceDetailForm';
import { getBaseCodes } from '../../../modules/auth';
import useActionPermission from '../../../hooks/useActionPermission';
import OrderBillReviewDialog from '../../project_orders/OrderBillReviewContainer';

const ChanceNeedsAnanlysisFormContainer = ({ stepperRef }) => {
  const arrayHelperRef = useRef();
  const costCalcApiRef = useRef();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { baseCodes, user, chance, costs } = useSelector(
    ({ auth, chanceModule }) => ({
      baseCodes: auth.baseCodes,
      user: auth.user,
      chance: chanceModule.chance.chance,
      costs: chanceModule.chanceCosts.costs,
    }),
  );

  const [itemCdOptions, setItemCdOptions] = useState([]);
  const [visible, setVisible] = useState(false);
  const onCancle = () => {
    setVisible(false);
  };
  const onConfirm = () => {
    setVisible(false);
  };
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [message, setMessage] = useState(
    '기본사항 등록이 완료되지 못했습니다.',
  );

  // 매입단가 0원 입력 차단. 서버도 다시 막는다(ExpenseService, bito 4단계 2026-10-20) — 여긴
  // 저장 전에 미리 알려주는 용도.
  const { allowed: canZeroPurchasePrice } = useActionPermission(
    'PURCHASE_PRICE_ZERO',
  );

  const checkValidation = () => {
    let valid = true;
    //원가산출 체크
    // if (formik.values.costCalcs?.length === 0) {
    //   setMessage(
    //     '원가 산출 제품을 추가하지 않았습니다. 원가 산출 내역을 확인하세요.',
    //   );
    //   valid = false;
    // }

    if (!canZeroPurchasePrice) {
      const hasZeroPrice = (formik.values?.costCalcs || []).some(
        (cost) => Number(cost.priceVal) === 0 || cost.priceVal === '' || cost.priceVal === null,
      );
      if (hasZeroPrice) {
        setMessage('매입단가가 0원인 항목이 있습니다. 매입단가를 입력하세요.');
        valid = false;
      }
    }

    return valid;
  };

  //id가 unquie한것만 선택.
  const onSelectedProducts = (data) => {
    const products = [...selectedProducts, ...data];
    const filteredProducts = _.uniqBy(products, 'id');

    filteredProducts.forEach((product) => {
      arrayHelperRef.current.push({
        expUuid: product.expUuid ? product.expUuid : '',
        masterTyp: 'N',
        priceUuid: product.priceUuid,
        sellPartnerUuid: product.partnerUuid,
        sellPartnerNm: product.partnerNm,
        partnerUuid: product.partnerUuid,
        partnerNm: product.partnerNm,
        productNm: product.productNm,
        productUuid: product.productUuid,
        expCnt: 1,
        unitVal: product.unitVal,
        priceVal: product.priceVal,
        productDesc: product.productDesc,
        productUnit: product.productUnit,
        itemCd: product.itemCd,
      });
    });
  };

  const handleExtProduct = () => {
    arrayHelperRef.current.push({
      masterTyp: 'E',
      priceUuid: null,
      sellPartnerUuid: '',
      sellPartnerNm: '',
      partnerUuid: null,
      partnerNm: null,
      productNm: '',
      productUuid: null,
      expCnt: 1,
      unitVal: 0,
      priceVal: 0,
      productDesc: '',
      productUnit: '',
      itemCd: '기타',
    });
  };

  const [initialValues, setInitialValues] = useState({
    cstNm: '',
    // partnerInc: '',
    prjTyp: '',
    incTyp: '',
    // solutionTyp: '',
    // chanceTyp: '',
    prjImpt: '',
    bugetYn: '',
    partnerTyp: '',
    procurement: false,
    // chargeNm: '',
    // chargeEml: '',
    // chargeTel: '',
    forcastTxt: '',
    productYn: '',
    vendorCmp: '',
    vendorCmpNm: '',
    // vendorEmp: '',
    expDay: '',
    crtUsr: user?.usrUuid,
    crtNm: user?.usrNm,
    costCalcs: [],
  });

  let validationSchema = yup.object({
    cstNm: yup.string('').required('사업명을 입력하세요'),
    //partnerInc: yup.string().required('고객명을 입력하세요'),
    prjTyp: yup.string().required('프로젝트 타입을 선택하세요'),
    incTyp: yup.string().nullable('거래처 유형을 선택하세요'),
    // solutionTyp: yup.string().nullable('아이템 구분을 선택하세요'),
    // chanceTyp: yup.string().nullable('기회유형을 선택하세요'),
    prjImpt: yup.string().nullable('프로젝트 중요도를 선택하세요'),
    bugetYn: yup.string().nullable('예산여부를 선택하세요'),
    // partnerTyp: yup.string().nullable('거래처유형을 선택하세요'),
    // chargeNm: yup.string().nullable('고객 담당자를 입력하세요'),
    // chargeEml: yup.string('').email('이메일 형식을 확인하세요').nullable(),
    // chargeTel: yup.string().nullable(),
    forcastTxt: yup.string().nullable(),
    productYn: yup.string().nullable('제품여부를 선택하세요'),
    vendorCmpNm: yup.string().nullable('매출처를 선택하세요'),
    // vendorEmp: yup.string().nullable('매출처 담당자를 선택하세요'),
    // expDay: yup.date().nullable().default(undefined),
    
  expDay: yup
  .date()
  // 1) 빈 문자열을 null로 변환
  .transform((value, originalValue) =>
    originalValue === '' ? null : value
  )
  .nullable()
  // 2) 형식 오류 시 보여줄 메시지
  .typeError('날짜 형식을 확인하세요')
  // 3) 필수 입력 시 보여줄 메시지
  .required('매출 예상일을 선택하세요'),
    // pmUsr: yup.string().nullable('PM을 선택하세요'),
    // plUsr: yup.string().nullable('PL을 선택하세요'),
    // techUsr: yup.string().nullable('기술담당자를 선택하세요'),
    crtNm: yup.string().nullable('영업담당자를 선택하세요'),
    costCalcs: yup.array().of(
      yup.object().shape({
        sellPartnerNm: yup.string('').required('매입처를 선택하세요'),
        expCnt: yup
          .number()
          // .min(1, '최소 1 이상을 입력하세요')
          .required('수량을 입력하세요'),
        unitVal: yup.number().required('매출단가를 입력하세요'),
        priceVal: yup.number().required('매입단가를 입력하세요'),
      }),
    ),
  });

  useEffect(() => {
    if (!baseCodes) {
      dispatch(getBaseCodes());
    } else {
      const filteredList = _.filter(baseCodes, {
        blcCd: 'BASE',
        mlcCd: 'PRODUCT',
        slcCd: 'CATEGORY',
        useYn: 'Y',
      }).map((item) => ({
        ...item,
        step: item.step !== '' && item.step !== null ? parseInt(item.step) : 0,
      }));
      //console.log(filteredList, filterObject);
      const orderedLiist = _.orderBy(filteredList, 'step');

      setItemCdOptions(orderedLiist);
    }
  }, [baseCodes]);

  useEffect(() => {
    if (chance) {
      dispatch(listChanceCosts(chance.prjUuid));
    }
  }, [chance]);

  useEffect(() => {
    if (costs) {
      const copyChance = {
        ...chance,
        procurement: chance?.procurement === 'Y' ? true : false,
      };
      const copyCosts = _.clone(costs);
      const init = { ...copyChance, costCalcs: copyCosts };
      setInitialValues(init);
    }
  }, [costs]);

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      const valid = checkValidation();

      if (!valid) {
        setVisible(true);
        return;
      } else {
        setSubmitting(true);
        onSave(values);
        formik.resetForm();
        setSubmitting(false);
      }

      stepperRef.current?.scrollIntoView({ behavior: 'smooth' }); //저장 후 stepper로 이동함.
    },
  });

  const onSave = async (values) => {
    let dataToSubmit = {
      prjUuid: chance.prjUuid,
      // partnerInc: values.partnerInc,
      cstNm: values.cstNm.trim(),
      prjTyp: values.prjTyp,
      //chanceTyp: values.chanceTyp,
      prjImpt: values.prjImpt,
      bugetYn: values.bugetYn,
      // partnerTyp: values.partnerTyp,
      chargeNm: values.chargeNm,
      chargeEml: values.chargeEml,
      chargeTel: values.chargeTel,
      forcastTxt: values.forcastTxt,
      incTyp: values.incTyp,
      // solutionTyp: values.solutionTyp,
      productYn: values.productYn,
      procurement: values?.procurement ? 'Y' : 'N',
      vendorCmp: values.vendorCmp,
      // vendorEmp: values.vendorEmp,
      customerUuid: values.customerUuid,
      crtUsr: values.crtUsr,
      expDay: values.expDay ? dayjs(values?.expDay).format('YYYY-MM-DD') : null,
    };

    //console.log(dataToSubmit, 'dataToSubmit');

    try {
      const res = await chanceApi.editChance(dataToSubmit);
      if (res.data.info) {
        const calcData = onMakeCaclData();
        const calcRes = await chanceApi.editCosts(chance.prjUuid, calcData);
        // console.log(JSON.stringify(dataToSubmit, 2, null), 'dataToSubmit');
        //console.log(JSON.stringify(calcData, 2, null), 'dataToSubmit');
        // console.log(calcRes.data.list, 'save');

        if (calcRes.data) {
          dispatch(setChance(res.data.info));
          dispatch(listChanceCosts(chance.prjUuid));
          enqueueSnackbar(`저장 성공`, {
            variant: 'success',
          });
        }
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };
  const onMakeCaclData = () => {
    return formik.values.costCalcs.map((item) => {
      const saleVal = Number(item.expCnt) * Number(item.unitVal);
      const buyVal = Number(item.expCnt) * Number(item.priceVal);
      // [버그수정, 2026-10-27] 예전엔 여기서 item.saleVal/item.buyVal(이전 렌더에서 표가
      // mutate해 둔 값)를 읽었다. 표 리뉴얼로 그 mutate를 없앴으므로, 이 함수 안에서 방금
      // 계산한 saleVal/buyVal로 직접 이익을 구한다.
      const profit = saleVal - buyVal;
      const profitRate = saleVal === 0 ? 0 : (profit / saleVal) * 100;

      return {
        expUuid: item.expUuid, //ID
        masterTyp: item.masterTyp, //기타, 일반항목 구분
        sellPartnerUuid: item.sellPartnerUuid, //매입사
        partnerUuid: item.partnerUuid, //제조사
        priceUuid: item.priceUuid,
        priceVal: item.priceVal,
        unitVal: item.unitVal,
        productNm: item.productNm,
        productUuid: item.productUuid,
        productDesc: item.productDesc,
        productUnit: item.productUnit,
        itemCd: item.itemCd, //아이템
        expCnt: item.expCnt,
        saleVal: saleVal,
        buyVal: buyVal,
        saleProfit: profit,
        salePct: profitRate,
      };
    });
  };

  // 합계(매출/매입/이익/이익율)는 CostCalcListForm이 표 안 합계 행에서 직접 계산해 보여준다
  // (2026-10-27 표 리뉴얼 전엔 여기서 따로 계산해 표 위 CostSummary에 내려줬었다).

  //원가산출 확정/ 해제
  const [lockMessage, setLockMessage] = useState(false);
  const handleLockOpen = () => setLockMessage(true);
  const handleLockClose = () => {
    setLockMessage(false);
  };
  const onCostLock = async () => {
    // [이슈 #3, 2026-10-21] 이 화면은 "저장" 버튼을 눌러야 formik의 costCalcs가
    // chanceApi.editCosts로 서버에 반영되는데(onSave), "원가산출 확정"(chanceApi.completeCost)은
    // 서버에 이미 저장된 값만 보고 확정 여부를 판단하는 별도 API다. 그리드에서 값을 고치고
    // 저장을 누르지 않은 채 바로 확정을 누르면 서버는 옛 값으로 확정을 시도해 불친절한 에러만
    // 뜨고, 새로고침하면 formik 메모리에만 있던 입력이 그대로 사라졌다(저장 안 됐으니 당연하지만
    // 사용자는 이유를 알 수 없었다). formik.dirty(초기값과 달라졌는지)로 아직 저장 안 된 변경이
    // 있는지 보고, 있으면 확정을 막고 안내한다.
    // [옵션 B, 2026-10-27] 표에 입력 오류(필수값 누락 등)가 있으면 확정 API를 부르기 전에
    // 막고, 그 줄을 선택해 패널을 열어 보여준다(CostCalcListForm의 ApiRef 참고).
    if (costCalcApiRef.current && !costCalcApiRef.current.validateAndFocusFirstInvalid()) {
      enqueueSnackbar('입력값을 확인해야 하는 품목이 있습니다.', { variant: 'warning' });
      return;
    }

    if (formik.dirty) {
      enqueueSnackbar(
        '저장하지 않은 입력이 있습니다. 먼저 "저장" 버튼을 눌러주세요.',
        { variant: 'warning' },
      );
      return;
    }

    const valid = checkValidation();

    if (valid) {
      try {
        const res = await chanceApi.completeCost(chance.prjUuid);
        if (res.data.result === 'SUCCESS') {
          dispatch(setChance(res.data.info));
          enqueueSnackbar('원가산출이 확정되었습니다', {
            variant: 'success',
          });
        } else {
          const message =
            res.data.result === 'NOT_VALID_COST_INFO'
              ? '원가산출을 확정할 수 없습니다(마이너스 원가)'
              : '원가산출을 확정할 수 없습니다';
          enqueueSnackbar(`${message}`, {
            variant: 'error',
          });
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }
    } else {
      handleLockOpen();
    }
  };

  const [unLockVisible, setUnlockVisible] = useState(false);
  // 재작성 가드(규칙 2, 2026-10-21): 발행완료된 세금계산서가 있으면 서버가 409로 막으면서
  // reviews(OrderBillReviewDto[])를 같이 돌려준다 - 번호만 보여주지 않고 이 자리에서 바로
  // 수금 취소 → 발행 취소까지 할 수 있게 같은 패널(OrderBillReviewPanel)을 그대로 띄운다.
  const [lockedReviews, setLockedReviews] = useState(null);
  const onUnLockCancle = () => {
    setUnlockVisible(false);
  };
  const onUnLockConfirm = () => {
    setUnlockVisible(false);
    onCostUnLock();
  };
  const onCostUnLock = async () => {
    try {
      const res = await chanceApi.unDoCost(chance.prjUuid);

      if (res.data.info) {
        dispatch(setChance(res.data.info));
        dispatch(chanceEstimateActive(chance.prjUuid));
        dispatch(chanceOrderCount(chance.prjUuid));
        enqueueSnackbar('원가산출이 해제되었습니다.', {
          variant: 'success',
        });
      }
    } catch (err) {
      const data = err?.response?.data;
      if (data?.result === 'LOCKED_INVOICE_EXISTS') {
        setLockedReviews(data.reviews || []);
        enqueueSnackbar(data.message, { variant: 'warning' });
        return;
      }
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  // 가드 패널에서 취소를 해서 막는 조건이 없어지면, 같은 버튼으로 바로 다시 시도할 수 있게
  // 안내만 하고 닫는다(자동 재시도는 하지 않는다 - 사용자가 상태를 눈으로 확인하고 눌러야 한다).
  const handleLockedReviewsChanged = () => {
    enqueueSnackbar('상태가 바뀌었습니다. 모두 취소됐으면 "원가산출 해제"를 다시 눌러주세요.', {
      variant: 'info',
    });
  };

  // [이슈 #3, 2026-10-21] 저장 안 한 채 새로고침/창닫기 하면 formik 메모리에만 있던 입력이
  // 그대로 사라진다 - onCostLock의 "먼저 저장하세요" 가드와 짝을 이루는 보완.
  useEffect(() => {
    if (!formik.dirty) {
      return undefined;
    }
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
      return '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [formik.dirty]);

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
      noValidate
      autoComplete="off"
      onSubmit={formik.handleSubmit}
    >
      {chance?.useYn === 'N' && (
        <DetailTemplate title="포캐스팅 실패 사유">
          <Box sx={{ whiteSpace: 'pre-line' }}>{chance?.failTxt}</Box>
        </DetailTemplate>
      )}

      <DetailTemplate title="포캐스팅 등록">
        <ChanceDetailForm formik={formik} chance={chance} />
      </DetailTemplate>

      <Box sx={{ my: 2 }}>
        {chance && chance?.costYn === 'Y' ? (
          <CostCalcLockContainer chance={chance} />
        ) : (
          <FormikProvider value={formik}>
            <CostCalcListForm
              formik={formik}
              ArrayHelperRef={arrayHelperRef}
              ApiRef={costCalcApiRef}
              selectedVendor={formik.values.vendorCmp}
              itemCdOptions={itemCdOptions}
              onSelectedProducts={onSelectedProducts}
              onAddEtcProduct={handleExtProduct}
            />
          </FormikProvider>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          my: 2,
        }}
      >
        {chance?.costYn === 'Y' ? (
          <Button
            variant="contained"
            color="warning"
            onClick={() => setUnlockVisible(true)}
          >
            원가산출 해제
          </Button>
        ) : (
          <Button variant="contained" color="warning" onClick={onCostLock}>
            원가산출 확정
          </Button>
        )}

        <Button type="submit" variant="outlined" disabled={formik.isSubmitting}>
          저장
        </Button>
      </Box>
      <AskDialog
        visible={lockMessage}
        title="원가산출 확정 확인"
        description={`원가산출내역에 입력되지 않은 항목이 있습니다\r\n 원가산출을 재확인하세요`}
        confirmText="닫기"
        onConfirm={handleLockClose}
        onCancle={handleLockClose}
      />
      <AskDialog
        visible={unLockVisible}
        title="프로젝트 원가 산출 해제"
        description={`원가산출을 해제하시겠습니까?\r\n작업된(견적서 / 수주품의서 ) 등의 사항을 다시 작성해야됩니다.`}
        confirmText="해제"
        onConfirm={onUnLockConfirm}
        onCancle={onUnLockCancle}
      />
      <AskDialog
        visible={visible}
        title="등록 오류"
        description={message}
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
      {lockedReviews && (
        <OrderBillReviewDialog
          open={Boolean(lockedReviews)}
          onClose={() => setLockedReviews(null)}
          initialReviews={lockedReviews}
          mode="guard"
          onChanged={handleLockedReviewsChanged}
        />
      )}
    </Box>
  );
};

export default ChanceNeedsAnanlysisFormContainer;
